<template>
  <el-popover
    :placement="props.placement"
    :width="300"
    trigger="click"
    :hide-after="0"
    v-model:visible="popoverVisible"
    style="border-radius: 15px !important"
  >
    <template #reference>
      <div class="tou-xiang">
        <img
          :src="baseUrl + userStore.headerImgUrl"
          :class="collapse ? 'default-header-img-collapse' : 'default-header-img-lg'"
          style="cursor: pointer"
          v-img-error:headerImgUrl-employee
          alt=""
        />
        <i
          class="iconfont color1 ic-absolute"
          v-if="csStatus == CSStatus.Free"
          style="font-size: 0.75rem"
          >&#xe612;</i
        >
        <i
          class="iconfont color2 ic-absolute"
          v-if="csStatus == CSStatus.Busy"
          style="font-size: 0.75rem"
          >&#xe610;</i
        >
        <i
          class="iconfont color3 ic-absolute"
          v-if="csStatus == CSStatus.Off"
          style="font-size: 0.75rem"
          >&#xe610;</i
        >
      </div>
    </template>

    <div>
      <div class="left-chat-modal-header j-row">
        <el-upload
          :before-upload="beforeUpload"
          ref="uploadRef"
          :show-file-list="false"
          accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
        >
          <!-- +baseUrl + '/user/'  -->
          <img
            :src="baseUrl + uploadImgUrl"
            class="default-header-img-max"
            v-img-error:headerImgUrl-employee
            alt=""
          />
        </el-upload>
        <div class="j-cloumn" style="margin-left: 0.75rem">
          <span class="user-name">{{ userStore.name }}</span>
          <span v-for="item in userStore.roleList" class="role-name" :key="item.id">{{
            _formatName(item)
          }}</span>
        </div>
      </div>
      <el-divider />

      <div class="left-chat-modal-bottom j-column">
        <div class="text-sp">
          <span class="t1" v-t="'USER.userid'"></span>
          <span class="t2">{{ userStore.shortId }}</span>
        </div>
        <div
          class="text-sp"
          v-if="userStore.permissionList && userStore.permissionList.includes('im:cs')"
        >
          <span class="t1" v-t="'USER.name'"></span>
          <span class="t2">{{ userStore.name }}</span>
        </div>
        <div class="text-sp">
          <span class="t1" v-t="'USER.account'"></span>
          <span class="t2">{{ userStore.accountName }}</span>
        </div>
        <div class="text-sp">
          <span class="t1" v-t="'USER.password'"></span>

          <span class="t2" v-show="!showPasswordFlag">********</span>
          <el-input
            v-model="password"
            v-show="showPasswordFlag"
            @blur="cPassWordModal"
            :placeholder="$t('USER.setTitle')"
            size="small"
            ref="passwordInput"
          />
          <el-button
            v-if="showPasswordFlag"
            type="primary"
            @mousedown="changepwd"
            style="margin-left: 3px"
            >{{ $t('COMMON.confirm') }}</el-button
          >

          <el-button
            v-show="!showPasswordFlag"
            type="primary"
            link
            size="small"
            style="margin-left: 0.5rem"
            @click="cPassWordModal"
            >{{ $t('USER.change') }}</el-button
          >
        </div>
      </div>

      <el-divider />

      <div class="j-row-center">
        <span v-t="'USER.language'"></span>
        <el-select
          v-model="selectLanaguage"
          :style="isMobile() ? 'margin-left: 10px; width: 45%' : 'margin-left: 10px; width: 8vw'"
          size="small"
          @change="changeLan"
        >
          <el-option
            v-for="item in ISO639List"
            :id="item.value"
            :label="item.text"
            :value="item.re"
            :key="item.value"
          />
        </el-select>
      </div>
      <el-divider />
      <div v-if="userStore.permissionList && userStore.permissionList.includes('im:cs')">
        <div
          class="icon-item"
          :class="{ active: csStatus === 'FREE' }"
          @click="changeCsStatus(CSStatus.Free)"
        >
          <i class="iconfont color1">&#xe612;</i>
          <span v-t="'USER.free'"></span>
        </div>
        <div
          class="icon-item"
          :class="{ active: csStatus === 'BUSY' }"
          @click="changeCsStatus(CSStatus.Busy)"
        >
          <i class="iconfont color2">&#xe610;</i>
          <span v-t="'USER.busy'"></span>
        </div>
        <div
          class="icon-item"
          :class="{ active: csStatus === 'OFF' }"
          @click="changeCsStatus(CSStatus.Off)"
        >
          <i class="iconfont color3">&#xe610;</i>
          <span v-t="'USER.off'"></span>
        </div>
        <el-divider />
      </div>
      <div style="display: flex; justify-content: center; width: 100%">
        <el-button type="primary" round @click="logoutUser" style="width: 90%">
          {{ $t('USER.loginout') }}
        </el-button>
      </div>
    </div>
    <Dialog
      v-model="dialogVisible"
      :title="$t('xr_translate_change')"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :width="isMobile() ? '85%' : '30%'"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-table :data="merchants" border highlight-current-row @current-change="changeMerchant">
            <el-table-column prop="name" :label="$t('t_belone')" align="center" />
          </el-table>
        </el-col>
        <el-col :span="12">
          <el-table
            :data="employees"
            border
            highlight-current-row
            @current-change="changeEmployee"
            ref="singleTableRef"
          >
            <el-table-column prop="employeeName" :label="$t('t_zuoxi')" align="center" />
          </el-table>
        </el-col>
      </el-row>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancel">{{ $t('COMMON.cancel') }}</el-button>
          <el-button type="primary" @click="confirm">
            {{ $t('COMMON.confirm') }}
          </el-button>
        </span>
      </template>
    </Dialog>
  </el-popover>
</template>

<script lang="ts" setup>
import { getCurrentInstance, ref, watch, nextTick } from 'vue'
import { useLangStore, useUserStore } from '@/stores'
import {
  changeHeaderImg,
  changeLanguage,
  changePassword,
  changeStatus,
  CSStatus,
  loginOut
} from '@/server/employee_request'
import { UploadRawFile, ElMessageBox, ElMessage } from 'element-plus'
import { ISO639List } from '@/api/language'
import { messageSuccess, messageWarning, messageError } from '@xr-util/xr-ui'
import { uploadFileAndDownload } from '@/utils/file2bite'
import { useI18n } from 'vue-i18n'
import moment from 'moment'
import { setMomentLang } from '@/utils/lang-moment'
import {
  querySessionOff,
  pageEmployeeCsList,
  preTranslateChange,
  transferCustomerList
} from '@/server/session_request'
import { uploadUrlImageFun } from '@/server/s3_request'

//@ts-ignore
// eslint-disable-next-line no-unsafe-optional-chaining
const { $t } = getCurrentInstance()?.appContext.config.globalProperties
// const baseUrl = import.meta.env.VITE_BASE_URL
const protocol = window.location.protocol
const hostname = window.location.hostname
const port = window.location.port
let baseUrl = protocol + '//' + hostname
if (port.trim()) {
  baseUrl = baseUrl + ':' + port
}
baseUrl = baseUrl + import.meta.env.VITE_GATEWAY + '/user/'
const userStore = useUserStore()
const langStore = useLangStore()

const { locale } = useI18n()

const dialogVisible = ref(false)
const popoverVisible = ref(false)
const previousCsStatus = ref(null)
const merchants = ref([])
const sessions = ref([])
const employees = ref([])
const tmpMerId = ref()
const bind = ref({})
const showPrompt = ref(false)
const showPasswordFlag = ref(false)
const password = ref('')
const selectLanaguage = ref(userStore.language)
const uploadImgUrl = ref(userStore.headerImgUrl)
watch(
  () => userStore.headerImgUrl,
  (newVal) => {
    uploadImgUrl.value = newVal
  }
)
const props = defineProps({
  collapse: {
    type: Boolean,
    default: false
  },
  placement: {
    type: Boolean,
    default: 'right'
  }
})
const isMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  // |ipad
  let flag = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
  return flag
}
const csStatus = ref(userStore.csStatus)
const _formatName = (item: { name: any }) => {
  if (item) {
    return item?.name || ''
  }
}

watch(
  () => userStore.csStatus,
  (newValue) => {
    csStatus.value = newValue
  }
)
watch(
  () => userStore.language,
  (newValue) => {
    selectLanaguage.value = newValue
  }
)
// 点击按钮时手动控制 Popover
const handlePopClick = () => {
  popoverVisible.value = !popoverVisible.value
}

/**
 * 退出登录
 */
const logoutUser = () => {
  ElMessageBox.confirm($t('BUSINESS.logout_message'), $t('BUSINESS.hint'), {
    confirmButtonText: $t('COMMON.sure'),
    cancelButtonText: $t('COMMON.cancel')
  })
    .then(() => {
      loginOut().then((res) => {
        if (res && res.code == '0') {
          console.log('退出登录成功')
        }
        userStore.setClickBtnOut(true)
        userStore.loginOut()
      })
    })
    .catch(() => {
      console.log('取消输入')
    })
}
/**
 * 转接会话
 */
const confirm = () => {
  if (merchants.value.length != Object.keys(bind.value).length) {
    messageWarning($t('t_no_transfer_session'))
    return
  }
  var count = 0
  Object.keys(bind.value).forEach((key) => {
    let se = sessions.value.filter((x) => {
      return x.merchantId == key + ''
    })
    var j = 0
    se.forEach((res, index) => {
      setTimeout(
        transferCustomerList({
          newEmployeeId: bind.value[key],
          sessionId: res.id,
          oldEmployeeId: userStore.id,
          userId: res.createUserId
        }),
        (index + 1) * 4000
      )
    })
    count++
    if (count == Object.keys(bind.value).length) {
      logoutUser()
    }
  })
  dialogVisible.value = false
  messageSuccess($t('BUSINESS.agent_set_success'))
}
const changeMerchant = (val: any) => {
  console.log(val)
  tmpMerId.value = val.id
  pageEmployeeCsList({
    merchantId: val.id
  }).then((res) => {
    if (res.code == '0') {
      employees.value = res.data.dataList
      if (bind.value[val.id]) {
        let index = employees.value.findIndex((arr) => arr.id == bind.value[val.id])
        setCurrent(employees.value[index])
      }
    }
  })
}
const singleTableRef = ref<InstanceType<typeof ElTable>>()
const setCurrent = (row?: any) => {
  singleTableRef.value!.setCurrentRow(row)
}
const changeEmployee = (val: any) => {
  if (val) {
    Reflect.set(bind.value, tmpMerId.value, val.id)
  }
}
const beforeUpload = async (rawFile: UploadRawFile) => {
  // uploadFileAndDownload(rawFile, false).then((res) => {
  //   if (res && res?.key && res.url) {
  //     uploadImgUrl.value = res.url
  //     const param = {
  //       headerImgUrl: res.key
  //     }
  //     changeHeaderImg(param).then((res) => {
  //       if (res && res.code == '0') {
  //         messageSuccess($t('BUSINESS.header_change_success'))
  //         userStore.queryUserInfo()
  //       }
  //     })
  //   }
  // })
  const isJPG =
    rawFile.type === 'image/jpeg' || rawFile.type === 'image/png' || rawFile.type === 'image/jpg'
  const isLt2M = rawFile.size / 1024 / 1024 < 2

  if (!isJPG) {
    messageError($t('SEND_SMS.upload-type-tip'))
    return false
  }
  if (!isLt2M) {
    messageError($t('SEND_SMS.upload-size-tip') + '2M')
    return false
  }
  const formData = new FormData()
  formData.append('file', rawFile)
  uploadUrlImageFun(formData).then((res) => {
    if (res && res?.data.key && res.data.url) {
      uploadImgUrl.value = res.data.url
      const param = {
        headerImgUrl: res.data.key
      }
      changeHeaderImg(param).then((res) => {
        if (res && res.code == '0') {
          messageSuccess($t('BUSINESS.header_change_success'))
          userStore.queryUserInfo()
        }
      })
    }
  })
  return false
}
/**
 * 更改语言
 */

const changeLan = async () => {
  if (!selectLanaguage.value) return

  // console.log('selectLanguage:', selectLanaguage.value)

  const arr = ISO639List.filter((item) => item && item.re == selectLanaguage.value)
  if (arr && arr.length > 0) {
    langStore.setLang(arr[0].value)
    locale.value = arr[0].value
    userStore.locale = arr[0].value
    if (arr[0].value == 'zh') {
      //2.8.1弃用 moment.lang  2.12.0已弃用moment.locale, 使用
      moment.updateLocale('zh-cn', null)
    } else {
      //moment.设置语言
      // moment.updateLocale(`${arr[0].value}`, null)
      setMomentLang(arr[0].value)
    }
  }
  changeLanguage({
    //@ts-ignore
    language: selectLanaguage.value
  }).then((res) => {
    if (res && res.code == '0') {
      messageSuccess($t('BUSINESS.lan_set_success'))
      userStore.queryUserInfo()
    }
  })
}

const cancel = async () => {
  if (previousCsStatus.value !== null) {
    await changeCsStatus(previousCsStatus.value, false)
    previousCsStatus.value = null // 重置为 null，以防止重复恢复
  }
  dialogVisible.value = false
  bind.value = {}
  employees.value = []
  sessions.value = []
  // await changeCsStatus(CSStatus.Free, false);
}
/**
 * 更改坐席状态
 *
 * @param value
 */
const changeCsStatus = async (value: string, showPrompt = true) => {
  previousCsStatus.value = userStore.csStatus
  //更改状态
  await changeStatus({
    //@ts-ignore
    csStatus: value
  }).then((res) => {
    if (res && res.code == '0' && value !== CSStatus.Off && showPrompt) {
      messageSuccess($t('BUSINESS.agent_set_success'))
    }
    if (value == CSStatus.Off) {
      querySessionOff({}).then((res) => {
        if (res.code == '0') {
          merchants.value = res.data.merchants
          sessions.value = res.data.sessions
        }
      })
      dialogVisible.value = true
    }
  })

  //查询用户信息
  await userStore.queryUserInfo()
}

/**
 * 更改密码
 *
 */
const passwordInput = ref()
const cPassWordModal = () => {
  //更改Mima
  showPasswordFlag.value = !showPasswordFlag.value
  nextTick(() => {
    passwordInput.value.focus()
  })
}

const changepwd = (event: any) => {
  event.stopPropagation() // 阻止事件冒泡
  if (password.value.length == 0) {
    messageWarning($t('BUSINESS.password_not_empty'))
    return
  } else if (password.value.length < 6) {
    messageWarning($t('BUSINESS.password_length_error'))
    return
  }

  changePassword({
    password: password.value
  }).then((res) => {
    if (res && res.code == '0') {
      messageSuccess($t('BUSINESS.password_success'))
      cPassWordModal()
    }
  })
  password.value = ''
}
defineExpose({ handlePopClick })
</script>

<style lang="scss" scoped>
.left-chat-modal-header {
  .user-name {
    font-size: 1.125rem;
    font-weight: 500;
    color: #434343;
  }
  .role-name {
    color: #bfbfbf;
    font-size: 0.875rem;
  }
}
.text-sp {
  margin-top: 0.75rem;
  display: flex;
  flex-direction: row;
  .t1 {
    width: 5.5rem;
    color: #bfbfbf;
    font-size: 0.875rem;
    display: flex;
  }
  .t2 {
    // margin-left: ;
    font-size: 0.875rem;
    color: #434343;
  }
}
.icon-item {
  width: 100%;
  height: 32px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    margin-left: 20px;
    font-size: 14px;
    color: #434343;
  }
  &.active {
    background: #e5f4ff;
  }
}
.icon-item:hover {
  background: #e5f4ff;
}
.color1 {
  color: rgb(50, 202, 100);
}
.color2 {
  color: rgb(249, 112, 42);
}
.color3 {
  color: rgb(101, 99, 98);
}
.log-out-item {
  height: 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}
.log-out-item:hover {
  background-color: #e5f4ff;
}
.tou-xiang {
  position: relative;

  .ic-absolute {
    position: absolute;
    bottom: -3px;
    right: 0;
  }
}
.user-img {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 4px;
}
:deep(.el-popover.el-popper) {
  border-radius: 15px !important;
}
</style>
